import axios from 'axios';

export const updateUserInterests = async (params) => {
  const { data } = await axios.post('/update-user-interests', params);

  return data;
};
